export default __webpack_public_path__ + "static/media/csvTemplate.db673fb9.csv";